'use client'

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SvgArrowRightIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "img",
    ref,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.793 19.707a1 1 0 0 1 0-1.414L14.086 12 7.793 5.707a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const ForwardRef = forwardRef(SvgArrowRightIcon);
ForwardRef.displayName = "ArrowRightIcon";

export { ForwardRef as default };
//# sourceMappingURL=ArrowRightIcon.mjs.map
